import { render, staticRenderFns } from "./personalCenter.vue?vue&type=template&id=50b5077d&scoped=true"
import script from "./personalCenter.vue?vue&type=script&lang=js"
export * from "./personalCenter.vue?vue&type=script&lang=js"
import style0 from "./personalCenter.vue?vue&type=style&index=0&id=50b5077d&prod&lang=less&scoped=true"
import style1 from "./personalCenter.vue?vue&type=style&index=1&id=50b5077d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b5077d",
  null
  
)

export default component.exports